import keys from '@debbie/common/dist/cache/keys.js';
import { ErrorYouAreAboutToMakePossibleUnintendedAdjustments, } from '@debbie/common/dist/economy/vouchers/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import q from '@debbie/cortex/dist/query.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { getErrorMessage } from '../../../utils/errors.js';
import Back from '../../Back.js';
import Errors from '../../Errors.js';
import CaseVoucherCreator from './CaseVoucherCreator.js';
const VoucherCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const createVoucherMutation = useMutation(async (newCaseVoucher) => {
        const caseVoucher = {
            ...newCaseVoucher,
            currency: props.singleCase.currency,
            caseId: props.caseId,
            referenceCaseVouchers: newCaseVoucher.referenceCaseVouchers &&
                newCaseVoucher.referenceCaseVouchers.map((caseVoucher) => ({
                    ...caseVoucher,
                    currency: props.singleCase.currency,
                    caseId: props.caseId,
                })),
        };
        const add = (preventAdjustments) => caseVouchersAPI.create(props.caseId, caseVoucher, {
            preventAdjustments: preventAdjustments,
        });
        try {
            await add(true);
        }
        catch (error) {
            if (
            // @ts-ignore
            error?.message?.indexOf(ErrorYouAreAboutToMakePossibleUnintendedAdjustments) !== -1) {
                if (!confirm(lang.billing.warnThisWillAffectBilling)) {
                    return;
                }
                await add(false);
            }
            else {
                throw error;
            }
        }
        props.onCreate();
        q.invalidate(keys.write.create(caseVouchersEntity));
    });
    const createVoucher = async (newCaseVoucher) => {
        await createVoucherMutation.mutate(newCaseVoucher);
    };
    const errorMessage = getErrorMessage(createVoucherMutation.error);
    return (React.createElement(React.Fragment, null,
        React.createElement(Back, { onClick: props.onBack, header: props.header ||
                lang.economyVoucherTypeLabels[props.voucherType.voucherTypeId] }),
        React.createElement(Wrapper, null,
            errorMessage !== null && React.createElement(Errors, { errors: [errorMessage] }),
            React.createElement(CaseVoucherCreator, { caseId: props.caseId, voucherType: props.voucherType, onCreate: createVoucher, caseVouchers: props.caseVouchers, creditorId: props.creditorId }))));
};
export default VoucherCreator;
const Wrapper = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  width: 400px;
`;
//# sourceMappingURL=VoucherCreator.js.map